import type { SidebarLink } from "@shared/types/models";

const links: SidebarLink[] = [
  {
    to: "/dashboard",
    labelKey: "dashboard",
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
  },
  {
    to: "/invoices",
    labelKey: "invoices",
    icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
  },
  { to: "/addresses", labelKey: "addresses", icon: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" },
  { to: "/actions", labelKey: "actions", icon: "M13 10V3L4 14h7v7l9-11h-7z" },
  {
    to: "/meter-readings",
    labelKey: "meterReadings",
    icon: "M13 10V3L4 14h7v7l9-11h-7z",
  },
  {
    to: "/analytics",
    labelKey: "analytics",
    icon: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2m0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
  },
  {
    to: "/settings",
    labelKey: "settings",
    icon: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c-.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z",
  },
  {
    to: "/admin/settings",
    labelKey: "adminSettings",
    icon: "M12.69 15.69l4.24-4.24L12.69 7.21M8.46 11.46l4.24 4.24m0-8.48L8.46 11.46M3 21h18",
    adminOnly: true,
  },
];

const styles = {
  overlay: "fixed inset-0 z-40 bg-black/60 transition-opacity duration-300 lg:hidden",
  aside:
    "fixed inset-y-0 left-0 z-50 flex flex-col bg-card border-r border-border/50 transform transition-all duration-300 ease-in-out lg:static lg:translate-x-0 lg:z-0 lg:shadow-none lg:border-r",
  asideOpen: "translate-x-0 w-72",
  asideClosed: "-translate-x-full w-72 overflow-hidden lg:w-72 lg:translate-x-0 lg:overflow-visible",
  header: "relative flex h-16 items-center gap-3 px-6 border-b border-border/50",
  nav: "relative flex-1 overflow-y-auto px-3 py-4 space-y-0.5",
  sectionLabel: "px-3 pb-1.5 pt-4 text-[11px] font-semibold uppercase tracking-widest text-muted-foreground/60",
  navLinkBase:
    "group relative z-10 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer select-none",
  navLinkActive: "text-primary font-semibold border-l-2 border-primary",
  navLinkInactive: "text-muted-foreground hover:bg-secondary/50 hover:text-foreground border-l-2 border-transparent",
  icon: "h-4.5 w-4.5 shrink-0",
  userSection: "relative border-t border-border/50",
  userContent: "flex items-center gap-3 px-4 py-3",
  avatar: "h-9 w-9 rounded-full gradient-brand flex items-center justify-center text-xs font-semibold text-white shadow-md shrink-0",
  userName: "text-sm font-semibold text-foreground truncate",
  userEmail: "text-xs text-muted-foreground truncate",
  logoutBtn: "p-2 rounded-md text-muted-foreground hover:bg-accent hover:text-foreground transition-all duration-200",
  mb1: "mb-1",
  navPill: "pointer-events-none absolute left-3 right-3 z-0 rounded-lg bg-primary/10 border border-primary/25 transition-all duration-300 ease-out",
};

export { links, styles };
